
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface MonthYearSelectProps {
  selectedMonth: number;
  selectedYear: number;
  onMonthChange: (month: number) => void;
  onYearChange: (year: number) => void;
}

export function MonthYearSelect({
  selectedMonth,
  selectedYear,
  onMonthChange,
  onYearChange
}: MonthYearSelectProps) {
  return (
    <div className="flex space-x-4 mb-6">
      <Select 
        value={selectedMonth.toString()} 
        onValueChange={(value) => onMonthChange(parseInt(value))}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="เลือกเดือน" />
        </SelectTrigger>
        <SelectContent>
          {[...Array(12)].map((_, index) => (
            <SelectItem key={index + 1} value={(index + 1).toString()}>
              {index + 1}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select 
        value={selectedYear.toString()} 
        onValueChange={(value) => onYearChange(parseInt(value))}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="เลือกปี" />
        </SelectTrigger>
        <SelectContent>
          {[2023, 2024, 2025].map((year) => (
            <SelectItem key={year} value={year.toString()}>
              {year}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
